<template>
    <div class="files-list-test">
        <h3>{{ isCount ? 'Тест сервиса: количество файлов формы' : 'Тест сервиса: список файлов формы' }}</h3>

        <b-form @submit.prevent="sendRequest">
            <b-form-row>
                <b-col cols="5">
                    <b-form-group label="Сервис">
                        <b-form-radio-group v-model="service" :options="serviceOptions" buttons button-variant="outline-primary" />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col cols="2">
                    <b-form-group label="cur_year">
                        <b-form-input v-model.number="params.cur_year" type="number" required />
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="year">
                        <b-form-input v-model.number="params.year" type="number" required />
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group label="variant">
                        <b-form-input v-model="params.variant" required />
                    </b-form-group>
                </b-col>
                <b-col v-if="!isCount" cols="2">
                    <b-form-group label="form (необязательно)">
                        <b-form-input v-model="params.form" />
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="spf (необязательно)">
                        <b-form-input v-model.number="params.spf" type="number" />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col cols="2">
                    <b-form-group label="abp">
                        <b-form-input v-model.number="params.abp" type="number" required />
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group :label="isCount ? 'prg (необязательно)' : 'prg'">
                        <b-form-input v-model.number="params.prg" type="number" :required="!isCount" />
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="ppr (необязательно)">
                        <b-form-input v-model.number="params.ppr" type="number" />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col cols="5">
                    <b-form-group label="Режим">
                        <b-form-radio-group v-model="mode" :options="availableModes" buttons button-variant="outline-primary" />
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group :label="mode === 'gu' ? 'Коды ГУ (через запятую)' : 'Коды БИН (через запятую)'">
                        <b-form-input v-model="codesInput" :placeholder="mode === 'gu' ? '2580201, 2580305' : '123456789012, 987654321098'" required />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col cols="5">
                    <b-form-group label="delta">
                        <b-form-radio-group v-model="deltaMode" :options="deltaModeOptions" buttons button-variant="outline-secondary" />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-button type="submit" variant="primary" :disabled="loading">
                <b-spinner v-if="loading" small class="mr-1" />
                Отправить запрос
            </b-button>
        </b-form>

        <div v-if="requestBody" class="mt-4">
            <h5>Запрос (POST {{ url }}):</h5>
            <pre class="request-block">{{ requestBody }}</pre>
        </div>

        <div v-if="response !== null" class="mt-3">
            <h5>Ответ:</h5>
            <pre :class="['response-block', error ? 'error' : 'success']">{{ response }}</pre>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FilesListTest',
    data() {
        return {
            service: 'list',
            serviceOptions: [
                { text: 'Список файлов', value: 'list' },
                { text: 'Количество файлов', value: 'count' }
            ],
            mode: 'gu',
            modeOptions: [
                { text: 'ГУ', value: 'gu' },
                { text: 'ГККП', value: 'gkkp' },
                { text: 'ГККП (платные)', value: 'gkkp-paid' }
            ],
            deltaMode: 'omit',
            deltaModeOptions: [
                { text: 'не отправлять', value: 'omit' },
                { text: 'null', value: 'null' },
                { text: 'true', value: 'true' },
                { text: 'false', value: 'false' }
            ],
            codesInput: '',
            params: {
                cur_year: new Date().getFullYear(),
                year: new Date().getFullYear(),
                variant: '',
                abp: null,
                prg: null,
                ppr: null,
                form: '',
                spf: null
            },
            loading: false,
            response: null,
            requestBody: null,
            error: false
        };
    },
    computed: {
        isCount() {
            return this.service === 'count';
        },
        availableModes() {
            return this.isCount ? this.modeOptions.filter(o => o.value !== 'gkkp-paid') : this.modeOptions;
        },
        url() {
            const kind = this.isCount ? 'count' : 'list';
            if (this.mode === 'gu') return `/api-py/get-files-${kind}-gu/`;
            if (this.mode === 'gkkp-paid') return '/api-py/get-files-list-gkkp-paid/';
            return `/api-py/get-files-${kind}-gkkp/`;
        }
    },
    watch: {
        service() {
            if (this.isCount && this.mode === 'gkkp-paid') this.mode = 'gkkp';
        }
    },
    methods: {
        async sendRequest() {
            const codes = this.codesInput.split(',').map(s => s.trim()).filter(Boolean);
            const body = { ...this.params };

            if (body.ppr === '' || isNaN(body.ppr)) body.ppr = null;

            // form и spf — взаимоисключающие (сервис требует ровно один, иначе 422).
            // Отправляем только заполненные; если заполнены оба или ни одного — шлём как есть для проверки 422.
            delete body.form;
            delete body.spf;
            if (typeof this.params.form === 'string' && this.params.form.trim() !== '') {
                body.form = this.params.form.trim();
            }
            if (typeof this.params.spf === 'number' && !isNaN(this.params.spf)) {
                body.spf = this.params.spf;
            }

            if (this.isCount) {
                // в сервисе количества prg, ppr и spf необязательны: пустые не отправляем, form там нет
                delete body.form;
                ['prg', 'ppr', 'spf'].forEach(key => {
                    if (typeof body[key] !== 'number' || isNaN(body[key])) delete body[key];
                });
            }

            if (this.deltaMode === 'true') body.delta = true;
            else if (this.deltaMode === 'false') body.delta = false;
            else if (this.deltaMode === 'null') body.delta = null;
            // 'omit': не добавляем поле вообще

            if (this.mode === 'gu') {
                body.gu = codes;
            } else {
                body.bin = codes;
            }


            this.requestBody = JSON.stringify(body, null, 2);
            this.loading = true;
            this.response = null;
            this.error = false;

            try {
                const res = await fetch(this.url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                });
                const data = await res.json();
                this.response = JSON.stringify(data, null, 2);
                this.error = !res.ok;
            } catch (e) {
                this.response = e.toString();
                this.error = true;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.files-list-test {
    padding: 24px;
    max-width: 900px;
}
pre {
    padding: 12px;
    border-radius: 6px;
    font-size: 0.85rem;
    white-space: pre-wrap;
    word-break: break-all;
}
.request-block {
    background: #f5f5f5;
    border: 1px solid #ddd;
}
.response-block.success {
    background: #f0fff4;
    border: 1px solid #38a169;
}
.response-block.error {
    background: #fff5f5;
    border: 1px solid #e53e3e;
}
</style>